import React, { useEffect, useState } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { formatMoneda } from "../../../util/varios";
import axios from "axios";
import useTableR from "../../useTableR";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import * as op from "../../../modulos/datos";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import moment from "moment";
const AnalisisModuloGestionCom = () => {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [selectAnio, setSelectAnio] = useState(anioActual);

  const [record, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fechas, setFechas] = useState({
    desde: `${selectAnio}-01-01`,
    hasta: new Date().toISOString().split("T")[0],
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    {
      id: "1",
      label: "N°",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "DESCRIPCIÓN",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "Créditos Actualizados",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "Monto Ejecutado",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "5",
      label: "% Ejecutado",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "6",
      label: "Monto Por Ejecutar",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "7",
      label: "% Por Ejecutar",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  // Función para calcular créditos actualizados
  const calcularCreditosActualizados = (item) => {
    const mtoInicial = parseFloat(item.cta_mtoinicial) || 0;
    const aumentado = parseFloat(item.cta_aumentado) || 0;
    const disminuido = parseFloat(item.cta_disminuido) || 0;
    return mtoInicial + aumentado - disminuido;
  };

  // Función para calcular si el monto es negativo (estilo rojo)
  const esNegativo = (item) => {
    const total = parseFloat(item.total) || 0;
    const creditosActualizados = calcularCreditosActualizados(item);
    return creditosActualizados > total;
  };

  // Función para calcular porcentaje ejecutado
  const calcularPorcEjecutado = (item) => {
    const total = parseFloat(item.total) || 0;
    const longit = parseInt(item.cta_longit);
    const creditosActualizados =
      longit < 7
        ? parseFloat(item?.sumHijos?.creditos || 0)
        : calcularCreditosActualizados(item);

    if (total === null || total === 0) return 0;
    if (creditosActualizados === 0) return 0;

    const porcentaje = (total / creditosActualizados) * 100;
    return Math.round(porcentaje * 100) / 100;
  };

  // Función para calcular monto por ejecutar
  const calcularMontoPorEjecutar = (item) => {
    const total = parseFloat(item.total) || 0;
    const longit = parseInt(item.cta_longit);

    const creditosActualizados =
      longit < 7
        ? parseFloat(item?.sumHijos?.creditos || 0)
        : calcularCreditosActualizados(item);
    const resultado = creditosActualizados - total;

    return resultado < 0 ? Math.abs(resultado) : resultado;
  };

  // Función para calcular porcentaje por ejecutar
  const calcularPorcPorEjecutar = (item) => {
    const total = parseFloat(item.total) || 0;
    const longit = parseInt(item.cta_longit);
    const creditosActualizados =
      longit < 7
        ? parseFloat(item?.sumHijos?.creditos || 0)
        : calcularCreditosActualizados(item);

    if (total === null || total === 0) return 100;
    if (creditosActualizados === 0) return 100;

    const porcentajeEjecutado = (total / creditosActualizados) * 100;

    if (porcentajeEjecutado > 100) return 0;

    return Math.round((100 - porcentajeEjecutado) * 100) / 100;
  };

  // Función para obtener el estilo del texto según el nivel y tipo de cuenta
  const getTextStyle = (item) => {
    const longit = parseInt(item.cta_longit);
    const isPadre = item.cta_padre === "true";
    const isAuxiliarCero = item.auxiliar === "0000";
    const isNegativoMonto = esNegativo(item);

    let style = {};

    // Nivel 1 (longitud = 3) - RUPT_1 - Color azul #000099 (como en el Jasper)
    if (longit === 3) {
      style = { color: "#000099", fontWeight: "bold" };
    }
    // Nivel 2 (longitud = 4 o 5) - RUPT_2 - Color verde #009900
    else if (longit === 4 || longit === 5) {
      style = { color: "#009900", fontWeight: "bold" };
    }
    // Nivel 3 (longitud >= 7 y cta_padre = true) - RUPT_3 - Fondo gris
    else if (longit >= 7 && isPadre) {
      style = { backgroundColor: "#F0F0F0", fontWeight: "normal" };
    }
    // Detalle (longitud >= 7 y cta_padre = false)
    else if (longit >= 7 && !isPadre) {
      style = { fontWeight: isAuxiliarCero ? "bold" : "normal" };
    }

    // Aplicar color rojo si estilo = false (monto negativo)
    // if (isNegativoMonto && longit >= 7 && !isPadre) {
    //   style = { ...style, color: "#FF0000" };
    // }

    return style;
  };

  // Función para obtener el estilo de fondo de la fila
  const getRowStyle = (item) => {
    const longit = parseInt(item.cta_longit);
    const isPadre = item.cta_padre === "true";

    // Para RUPT_3 (cuentas padre nivel 3) - fondo gris
    if (longit >= 7 && isPadre) {
      return { backgroundColor: "#F0F0F0" };
    }

    // Para las demás filas, fondo blanco
    return { backgroundColor: "#FFFFFF" };
  };

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTableR(
    record,
    headCells,
    filterFn,
    true,
  );
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cta_literal.includes(target.value) ||
              x.pre_descri.toLowerCase().includes(target.value.toLowerCase()) ||
              x.total.toLowerCase().includes(target.value.toLowerCase()) ||
              x.cta_mtoinicial
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.cta_disminuido
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.cta_aumentado.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const campos = "*";
      const nomtab = `reporte_presupuesto_ingresos('${fechas.desde}'::date, '${fechas.hasta}'::date, ${idefiscal})`;
      const orden = `1=1`;
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        const datosFormat = formatearDatos(response.data);
        setRecords(datosFormat);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Buscar los Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const formatearDatos = (datos) => {
    try {
      if (!datos) return [];
      const nuevosDatos = [...datos];
      nuevosDatos.forEach((item) => {
        const longit = parseInt(item.cta_longit);
        const codigo = item.cta_literal;
        if (longit >= 7) {
          const codigoPadre = codigo.substring(0, 5);
          const padre = nuevosDatos.find(
            (p) => p.cta_literal.substring(0, 5) === codigoPadre,
          );
          if (!padre.sumHijos) {
            padre.sumHijos = { creditos: 0 };
          }
          padre.sumHijos.creditos += calcularCreditosActualizados(item);
        }
      });
      nuevosDatos.forEach((item) => {
        const longit = parseInt(item.cta_longit);
        const codigo = item.cta_literal;
        if (longit === 4 || longit === 5) {
          const codigoAbuelo = codigo.substring(0, 3);
          const abuelo = nuevosDatos.find(
            (a) => a.cta_literal.substring(0, 3) === codigoAbuelo,
          );
          if (abuelo) {
            if (!abuelo.sumHijos) {
              abuelo.sumHijos = { creditos: 0 };
            }
            const creditosPadre = item.sumHijos
              ? item.sumHijos.creditos
              : calcularCreditosActualizados(item);
            abuelo.sumHijos.creditos += creditosPadre;
          }
        }
      });
      return nuevosDatos;
    } catch (error) {
      console.warn(error);
    }
  };
  const imprimirReporteGraficas = async () => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");

      // Configuración de alta calidad
      const scale = 3;
      const margin = 15;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const contentWidth = pageWidth - margin * 2;

      // Mostrar loading mientras se genera el PDF
      setLoading(true);

      // Obtener todas las gráficas
      const graficasElements = document.querySelectorAll(".grafica-pdf");

      if (graficasElements.length === 0) {
        setMensaje({
          mostrar: true,
          titulo: "Sin datos",
          texto: "No hay gráficas para exportar",
          icono: "warning",
        });
        setLoading(false);
        return;
      }

      // Agregar título al PDF
      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.text("REPORTE DE EJECUCIÓN PRESUPUESTARIA", margin, margin);
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      pdf.text(
        `Período: ${moment(fechas.desde).format("DD-MM-YYYY")} al ${moment(fechas.hasta).format("DD-MM-YYYY")}`,
        margin,
        margin + 7,
      );
      let currentPage = 1;
      let yOffset = margin + 25;

      // ==================== SECCIÓN 1: TABLA DE DATOS ====================
      // Función para preparar los datos de la tabla
      const prepararDatosTabla = () => {
        if (!record) return [];

        const datos = [];

        recordsAfterPagingAndSorting()
          .filter((item) => {
            // APLICAR EL MISMO FILTRO QUE EL JASPER
            const longit = parseInt(item.cta_longit);
            const esPadre = item.cta_padre === "true";

            // El Jasper muestra:
            // 1. RUPT_1: cuando cta_longit == 3
            if (longit === 3) return true;

            // 2. RUPT_2: cuando cta_longit == 4 o 5
            if (longit === 4 || longit === 5) return true;

            // 3. Detail: cuando cta_longit >= 7 y cta_padre == "false"
            if (longit >= 7 && !esPadre) return true;

            // 4. NO mostrar: cta_longit >= 7 y cta_padre == "true" (son solo encabezados en Jasper)
            return false;
          })
          .forEach((item, index) => {
            const longit = parseInt(item.cta_longit);
            const creditosActualizados =
              longit < 7
                ? parseFloat(item?.sumHijos?.creditos || 0)
                : calcularCreditosActualizados(item);
            const montoEjecutado = parseFloat(item.total) || 0;
            const porcentajeEjecutado = calcularPorcEjecutado(item);
            const montoPorEjecutar = calcularMontoPorEjecutar(item);
            const porcentajePorEjecutar = calcularPorcPorEjecutar(item);

            // Formatear moneda (usando tu función formatMoneda existente)
            const formatMoney = (value) => {
              return formatMoneda(
                value.toString().replace(".", ","),
                ",",
                ".",
                2,
              );
            };

            // Crear fila para la tabla
            const fila = [
              item.cta_literal || "",
              item.pre_descri || "",
              formatMoney(creditosActualizados),
              formatMoney(montoEjecutado),
              `${porcentajeEjecutado}%`,
              formatMoney(montoPorEjecutar),
              `${porcentajePorEjecutar}%`,
            ];

            datos.push(fila);
          });

        return datos;
      };
      const allRecords = recordsAfterPagingAndSorting();

      const itemsFiltrados = allRecords.filter((item) => {
        const longit = parseInt(item.cta_longit);
        const esPadre = item.cta_padre === "true";

        if (longit === 3) return true;
        if (longit === 4 || longit === 5) return true;
        if (longit >= 7 && !esPadre) return true;
        return false;
      });
      const datosTabla = prepararDatosTabla();

      if (datosTabla.length > 0 && typeof autoTable === "function") {
        autoTable(pdf, {
          startY: yOffset,
          head: [
            [
              "N°",
              "DESCRIPCIÓN",
              "CRÉDITOS ACTUALIZADOS",
              "MONTO EJECUTADO",
              "% EJECUTADO",
              "MONTO POR EJECUTAR",
              "% POR EJECUTAR",
            ],
          ],
          body: datosTabla,
          theme: "grid",
          styles: {
            fontSize: 7,
            cellPadding: 2,
            halign: "right",
            valign: "middle",
            lineColor: [200, 200, 200],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
            fontSize: 8,
            cellPadding: 3,
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245],
          },
          columnStyles: {
            0: { halign: "left", cellWidth: 17 },
            1: { halign: "left", cellWidth: 50 },
            2: { halign: "right", cellWidth: 27 },
            3: { halign: "right", cellWidth: 27 },
            4: { halign: "center", cellWidth: 22 },
            5: { halign: "right", cellWidth: 25 },
            6: { halign: "center", cellWidth: 20 },
          },
          margin: { left: margin, right: margin },
          // Aplicar color rojo para valores negativos
          didParseCell: (data) => {
            const item = itemsFiltrados[data.row.index];
            if (item) {
              const isNegativoMonto = esNegativo(item);
              const isAzul = parseInt(item.cta_longit) === 3;
              const isVerde =
                parseInt(item.cta_longit) === 4 ||
                parseInt(item.cta_longit) === 5;
              if (
                isNegativoMonto &&
                parseInt(item.cta_longit) >= 7 &&
                item.cta_padre !== "true"
              ) {
                // Para la columna de porcentaje también
                if (data.column.index > 1) {
                  data.cell.styles.textColor = [255, 0, 0];
                }
              } else if (isAzul) {
                data.cell.styles.textColor = [0, 0, 128];
              } else if (isVerde) {
                data.cell.styles.textColor = [18, 176, 32];
              }
            }
          },
        });

        // Actualizar yOffset después de la tabla
        yOffset = pdf.lastAutoTable.finalY + 15;
        currentPage = pdf.internal.getNumberOfPages();
      }

      // ==================== SECCIÓN 2: GRÁFICAS ====================
      // Procesar cada gráfica
      for (let i = 0; i < graficasElements.length; i++) {
        const graficaElement = graficasElements[i];
        pdf.addPage();
        currentPage++;
        yOffset = margin;

        // Agregar encabezado en nueva página
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "italic");
        // Configuración mejorada de html2canvas
        const canvas = await html2canvas(graficaElement, {
          scale: scale,
          backgroundColor: "#ffffff",
          logging: false,
          useCORS: true,
          allowTaint: false,
          windowWidth: graficaElement.scrollWidth,
          windowHeight: graficaElement.scrollHeight,
          onclone: (clonedDoc, element) => {
            const clonedGrafica = clonedDoc.querySelector(".grafica-pdf");
            if (clonedGrafica) {
              clonedGrafica.style.background = "#ffffff";
              const allElements = clonedGrafica.querySelectorAll("*");
              allElements.forEach((el) => {
                el.style.fontFamily = "Arial, sans-serif";
              });
            }
          },
        });

        // Convertir a PNG con alta calidad
        const imgData = canvas.toDataURL("image/png", 1);
        // Calcular dimensiones manteniendo proporción
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Agregar título de la gráfica
        pdf.setFontSize(11);
        pdf.setFont("helvetica", "bold");

        // Agregar imagen al PDF
        pdf.addImage(imgData, "PNG", margin, yOffset, imgWidth, imgHeight);
        yOffset += imgHeight + 15;
      }

      // ==================== SECCIÓN 3: PIE DE PÁGINA ====================
      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8);
        pdf.setFont("helvetica", "italic");
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${pageCount}`,
          margin,
          pdf.internal.pageSize.getHeight() - 10,
        );
      }

      // ==================== GUARDAR O MOSTRAR PDF ====================
      // Opción 1: Guardar como archivo
      // const nombreArchivo = `reporte_gestion_${fechas.desde}_al_${fechas.hasta}.pdf`;
      // pdf.save(nombreArchivo);

      // Opción 2: Abrir en nueva ventana (recomendado)
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(
        pdfUrl,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );

      // Limpiar la URL después de 5 segundos
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 5000);
    } catch (error) {
      console.error("Error al generar el PDF:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "No se pudo generar el PDF: " + error.message,
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimirReporte = () => {
    try {
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=Pres_IngrEdoEjecCredi" +
          "&sql1=" +
          idefiscal +
          "&sql3=" +
          `'${fechas.desde}'` +
          "&sql4=" +
          `'${fechas.hasta}'`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {}
  };
  useEffect(() => {
    buscarRegistros();
  }, [fechas]);

  return (
    <div className="col-md-12 m-auto overflow-scroll">
      <div className="row p-0 m-0 w-100 d-flex justify-content-between">
        {record &&
          record
            .filter((padre) => parseInt(padre.cta_longit) === 3)
            .map((padre, index) => {
              const codigoPadre = padre.cta_literal.substring(0, 3);
              const hijos = record.filter(
                (hijo) =>
                  parseInt(hijo.cta_longit) >= 7 &&
                  hijo.cta_literal.substring(0, 3) === codigoPadre,
              );
              const dataGrafica = hijos.map((hijo) => ({
                name: hijo.pre_descri,
                creditos: calcularCreditosActualizados(hijo),
                ejecutado: parseFloat(hijo.total) || 0,
                porEjecutar: calcularMontoPorEjecutar(hijo),
              }));
              if (dataGrafica.length === 0) return null;
              return (
                <div
                  className={`card shadow-sm border-2 ${dataGrafica.length > 10 ? "col-md-12 " : "col-md-4"} mt-2 grafica-pdf`}
                  key={`grafica-nivel1-${index}`}
                >
                  <div
                    className="card p-3 h-100 shadow-sm border-0"
                    style={{ background: "#f8fafc" }}
                  >
                    {/* Título con datos del PADRE (nivel 1) */}
                    <h5
                      className="text-uppercase fw-bold mb-3"
                      style={{ fontSize: "11px", color: "#000099" }}
                    >
                      {padre.cta_literal} - {padre.pre_descri}
                    </h5>

                    {/* UNA SOLA gráfica con TODOS los hijos como barras agrupadas */}
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart
                        data={dataGrafica}
                        margin={{ top: 10, right: 10, left: 15, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis
                          dataKey="name"
                          style={{ fontSize: "8px", fontWeight: "600" }}
                          tick={{
                            fontSize: 8,
                            angle: -20, // Rotación de -45 grados (puedes usar 45, -45, 90, -90)
                            textAnchor: "end", // Alineación del texto cuando está rotado
                          }}
                          interval={0}
                          height={100} // Aumentar la altura para dar espacio al texto rotado
                        />
                        <YAxis
                          scale="log"
                          domain={[1, "auto"]}
                          allowDataOverflow
                          style={{ fontSize: "9px" }}
                          tickFormatter={(value) =>
                            formatMoneda(
                              value.toString().replace(".", ","),
                              ",",
                              ".",
                              0,
                            )
                          }
                        />
                        <Tooltip
                          formatter={(value) =>
                            formatMoneda(
                              value.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          }
                        />
                        <Bar
                          dataKey="creditos"
                          name="Créditos Actualizados"
                          fill="#3d8bfd"
                          radius={[4, 4, 0, 0]}
                        />
                        <Bar
                          dataKey="ejecutado"
                          name="Monto Ejecutado"
                          fill="#10b981"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              );
            })}
      </div>
      <div className="card mt-3 border-table mb-2">
        <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
          <h3 className="fw-bold text-light m-0">
            ESTADO FINANCIERO DE EJECUCIÓN DEL PRESUPUESTO DE INGRESOS
          </h3>
        </header>
        <div className="card-header bg-white border-0">
          <div className="d-flex justify-content-between align-items-center">
            <div className="col-3 input-group input-group-sm m-1 p-1 mr-auto">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control rounded-pill search-input"
                placeholder="Buscar..."
              />
            </div>
            <div className="d-flex gap-2 align-items-center">
              <div
                className="input-group input-group-sm mb-0"
                style={{ width: "150px" }}
              >
                <span className="input-group-text text-uppercase">
                  Desde El Año
                </span>
                <select
                  className="form-control text-uppercase"
                  value={selectAnio}
                  onChange={(e) => {
                    setSelectAnio(e.target.value);
                    setFechas((prev) => ({
                      ...prev,
                      desde: `${e.target.value}-01-01`,
                    }));
                  }}
                >
                  {anios.map((e, index) => (
                    <option key={index} value={e}>
                      {e}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className="input-group input-group-sm mb-0"
                style={{ width: "180px" }}
              >
                <span className="input-group-text text-uppercase">Hasta</span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.hasta}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      hasta: e.target.value,
                    }));
                  }}
                />
              </div>
              <button
                onClick={() => imprimirReporteGraficas()}
                className="btn btn-sm btn-info rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "31px", height: "31px", padding: 0 }}
              >
                <i className="fas fa-print"></i>
              </button>
              <button
                onClick={() => imprimirReporte()}
                className="btn btn-sm btn-success rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "31px", height: "31px", padding: 0 }}
              >
                <i className="fas fa-print"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {record &&
                recordsAfterPagingAndSorting()
                  .filter((item) => {
                    // APLICAR EL MISMO FILTRO QUE EL JASPER
                    const longit = parseInt(item.cta_longit);
                    const esPadre = item.cta_padre === "true";

                    // El Jasper muestra:
                    // 1. RUPT_1: cuando cta_longit == 3
                    if (longit === 3) return true;

                    // 2. RUPT_2: cuando cta_longit == 4 o 5
                    if (longit === 4 || longit === 5) return true;

                    // 3. Detail: cuando cta_longit >= 7 y cta_padre == "false"
                    if (longit >= 7 && !esPadre) return true;

                    // 4. NO mostrar: cta_longit >= 7 y cta_padre == "true" (son solo encabezados en Jasper)
                    return false;
                  })
                  .map((item, index) => {
                    const textStyle = getTextStyle(item);
                    const rowStyle = getRowStyle(item);
                    const isNegativoMonto = esNegativo(item);
                    return (
                      <tr
                        key={index}
                        style={{
                          padding: "0",
                          ...rowStyle,
                        }}
                      >
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "left",
                            width: "auto",
                            ...textStyle,
                          }}
                        >
                          {item.cta_literal && item.cta_literal.length >= 9
                            ? `${item.cta_literal.substring(0, 3)}-${item.cta_literal.substring(3, 5)}-${item.cta_literal.substring(5, 7)}-${item.cta_literal.substring(7, 9)}-${item.auxiliar}`
                            : item.cta_literal}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "left",
                            width: "auto",
                            ...textStyle,
                          }}
                        >
                          {item.pre_descri}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "right",
                            width: "auto",
                            ...textStyle,
                          }}
                        >
                          {parseInt(item.cta_longit) >= 7
                            ? formatMoneda(
                                calcularCreditosActualizados(item)
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )
                            : formatMoneda(
                                (item?.sumHijos?.creditos || 0)
                                  .toString()
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "right",
                            width: "auto",
                            ...(isNegativoMonto &&
                            parseInt(item.cta_longit) >= 7 &&
                            item.cta_padre !== "true"
                              ? textStyle
                              : textStyle),
                          }}
                        >
                          {formatMoneda(
                            (parseFloat(item.total) || 0)
                              .toString()
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "right",
                            width: "auto",
                            ...(isNegativoMonto &&
                            parseInt(item.cta_longit) >= 7 &&
                            item.cta_padre !== "true"
                              ? { color: "#FF0000" }
                              : textStyle),
                          }}
                        >
                          {calcularPorcEjecutado(item)}%
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "right",
                            width: "auto",
                            ...(isNegativoMonto &&
                            parseInt(item.cta_longit) >= 7 &&
                            item.cta_padre !== "true"
                              ? { color: "#FF0000" }
                              : textStyle),
                          }}
                        >
                          {formatMoneda(
                            calcularMontoPorEjecutar(item)
                              .toString()
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "10px",
                            textAlign: "right",
                            width: "auto",
                            ...(isNegativoMonto &&
                            parseInt(item.cta_longit) >= 7 &&
                            item.cta_padre !== "true"
                              ? { color: "#FF0000" }
                              : textStyle),
                          }}
                        >
                          {calcularPorcPorEjecutar(item)}%
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </TblContainer>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </div>
  );
};

export default AnalisisModuloGestionCom;
